var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBreackSystem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3049_56952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 33,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4974 33.3639C27.8616 33.3639 33.8307 27.3948 33.8307 20.0306C33.8307 12.6664 27.8616 6.69727 20.4974 6.69727C13.1332 6.69727 7.16406 12.6664 7.16406 20.0306C7.16406 27.3948 13.1332 33.3639 20.4974 33.3639Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4974 23.364C21.3815 23.364 22.2293 23.0128 22.8544 22.3877C23.4795 21.7626 23.8307 20.9147 23.8307 20.0307C23.8307 19.1466 23.4795 18.2988 22.8544 17.6737C22.2293 17.0485 21.3815 16.6973 20.4974 16.6973C19.6133 16.6973 18.7655 17.0485 18.1404 17.6737C17.5153 18.2988 17.1641 19.1466 17.1641 20.0307C17.1641 20.9147 17.5153 21.7626 18.1404 22.3877C18.7655 23.0128 19.6133 23.364 20.4974 23.364ZM20.4974 3.36401C22.6861 3.36401 24.8534 3.79511 26.8755 4.63269C28.8975 5.47027 30.7349 6.69792 32.2825 8.24557C33.8302 9.79321 35.0578 11.6305 35.8954 13.6526C36.733 15.6747 37.1641 17.842 37.1641 20.0307H30.5024C30.5024 17.3772 29.4483 14.8324 27.572 12.9561C25.6957 11.0798 23.1509 10.0257 20.4974 10.0257V3.36401Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3049_56952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.0307617H40.5V40.0308H0.5V0.0307617Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreackSystem);
export default __webpack_public_path__ + "static/media/BreackSystem.1cfcfba2b24a372502cabea65d99448d.svg";
export { ForwardRef as ReactComponent };